import { Select } from "./components";
import { useState } from "react";
import { useEsmAccess } from "./FeatureAccess";
const pieces = [
  [
    "esm-project",
    "ESM project editor",
    "Edit ESM project JSON and return updated tables to a .NET host.",
  ],
  [
    "form",
    "Drop-in form",
    "A standalone form definition or a project, with optional external data.",
  ],
  [
    "form-configuration",
    "Form builder",
    "Build and save form definitions through your host application.",
  ],
  [
    "authoring",
    "Document designer",
    "Design documents with the tools and permissions you choose.",
  ],
  [
    "configuration",
    "Configuration editor",
    "Edit configuration through host callbacks without API access.",
  ],
  [
    "project-export",
    "Project export",
    "Export selected project content through your permitted services.",
  ],
  [
    "document-import",
    "Document import",
    "Import documents through your configured import services.",
  ],
  [
    "revision-review",
    "Revision review",
    "Compare and apply revisions with your review services.",
  ],
  ["font-library", "Font library", "Manage fonts using your library services."],
  [
    "asset-library",
    "Asset library",
    "Manage assets using your library services.",
  ],
  [
    "bulk-generation",
    "Bulk generation",
    "Generate batches through your configured batch services.",
  ],
  [
    "client",
    "API client",
    "Call permitted APIs without registering any widgets.",
  ],
] as const;
export function IntegrationPackages() {
  const esmAllowed = useEsmAccess();
  const [selected, setSelected] = useState("form");
  const [whole, setWhole] = useState(false);
  const piece = pieces.find((row) => row[0] === selected)!;
  const entry = whole ? "suite" : selected;
  const tag = selected === "client" ? "" : `proof-${selected}`;
  return (
    <details className="panel padded">
      <summary>Use individual tools or the full package</summary>
      <p>
        Choose one tool, combine several, or load the whole suite. Each tool
        keeps its own configuration. API access still follows your integration
        permissions.
      </p>
      <label>
        Tool{" "}
        <Select
          value={selected}
          onChange={(event) => setSelected(event.target.value)}
        >
          {pieces
            .filter(([key]) => esmAllowed || key !== "esm-project")
            .map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
        </Select>
      </label>
      <p>{piece[2]}</p>
      <label>
        <input
          type="checkbox"
          checked={whole}
          onChange={(event) => setWhole(event.target.checked)}
        />{" "}
        Load the full package
      </label>
      <pre>{`<script type="module" src="${window.location.origin}/plugins/${entry}.mjs"></script>${tag ? `\n<${tag} id="tool"></${tag}>` : ""}`}</pre>
      <p>
        Set the element's properties and host callbacks after its custom element
        is defined. For API-backed tools, obtain a short-lived token through
        your backend; keep client credentials there. Loading the full package
        does not grant additional access.
      </p>
      <p>For a package-based host:</p>
      <pre>{`import { ${
        selected === "client"
          ? "ProofClient"
          : "Proof" +
            selected
              .split("-")
              .map((part) => part[0].toUpperCase() + part.slice(1))
              .join("") +
            "Element"
      } } from "@proof/sdk${whole ? "" : "/" + selected}";`}</pre>
      <p>
        Background removal runs on the proof server, so no extra module is
        needed. A standalone tool can still require its own document, host
        callbacks, or authorized services.
      </p>
    </details>
  );
}
